import React, {Component} from 'react';
import {connect} from 'react-redux';
import BrandedSpinner from './common/BrandedSpinner';

class MiniLoader extends Component{
    constructor(props) {
        super(props);
        this.translations = JSON.parse(props.translations);
    }

    render() {
        const flights = this.props.flights;
        // genuinely searching: the import stream is still running
        const streaming = !flights.loading && !flights.importEnded && !flights.cachedResults;
        // a filter/sort request is in flight
        const filtering = !!(flights.overlaying && flights.overlaying.toggle);

        if (!streaming && !filtering) {
            return null;
        }

        return (
            <BrandedSpinner
                title={this.translations['Searching for flights offers']}
                subtitle={`${this.translations['Found flights']}: ${flights.count}`}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        parameters: state.ParametersReducer.parameters,
        flights: state.FlightsReducer
    }
}

export default connect(mapStateToProps)(MiniLoader);



// WEBPACK FOOTER //
// ./src/components/MiniLoader.js